import styled from 'styled-components';

const TitlePayment = styled.div`
	h4 {
		color: ${({ theme }) => theme.colorTitlePayment};
		font-family: ${({ theme }) => theme.fontFamilyTitlePayment};
		font-weight: ${({ theme }) => theme.fontWeightTitlePayment};
	}
	.swiper-container {
		//height: 23px;
		width: 144px;
		background-color: ${({ theme }) => theme.BackgroundColorTimeLine};
		margin: auto;
		border-radius: 0px;
		padding: 0px 8px;
	}
	span {
		color: ${({ theme }) => theme.textSpanTimeLine};
		font-size: 13px;
		font-family: ${({ theme }) => theme.fontFamilyTimeLine};
		font-weight: ${({ theme }) => theme.fontWeightTimeLine};
	}
`;

export default TitlePayment;
